import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { take } from 'rxjs';
import { UserService } from 'src/app/core/api/user/user.service';
import { RegisterService } from 'src/app/core/services/register/register.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { SideMenuItems } from 'src/app/shared/models/side-menu-items/side-menu-items';
import { RoutesKeys } from 'src/app/utils/routes';

@Component({
  selector: 'app-side-menu-desktop',
  templateUrl: './side-menu-desktop.component.html',
  styleUrls: ['./side-menu-desktop.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Side menu
 */
export class SideMenuDesktopComponent {
  @Input() sideMenuItems: SideMenuItems = new SideMenuItems();
  flatNavItems: any;
  expandedNavItems: any;
  RoutesKeys = RoutesKeys;
  expandedHelpItems: any;
  helpMenuItem: any;
  helpLabel: any;

  /**
   * @constructor
   */
  constructor(
    private router: Router,
    public translationService: TranslationService,
    public userService: UserService,
    public registerService: RegisterService
  ) {}

  /**
   * ngOnInit
   */
  ngOnInit() {
    this.flatNavItems = this.sideMenuItems.flatNavItems;
    this.expandedNavItems = this.sideMenuItems.expandedMenuNavItems;
    this.expandedHelpItems = this.sideMenuItems.expandedHelpMenuItems;
    this.helpMenuItem = this.sideMenuItems.help;
    this.translateItems(this.flatNavItems);
    this.translateItems(this.expandedNavItems);
    this.translateItems(this.expandedHelpItems);
    this.translateItems([this.helpMenuItem]);
  }

  /**
   * Navigate to router
   * @param {string} route
   */
  onRoute(route: string) {
    if (route.includes('terms-of-use')) {
      this.registerService
        .getTermsOfUseAndPrivacyConditionsURLs()
        .pipe(take(1))
        .subscribe({
          next: (goTo: any) => {
            window.open(goTo.termsOfUseURL);
          },
        });
    } else if (route.includes('faq')) {
      const url = this.router.url.substring(0, this.router.url.indexOf('/'));
      window.open(url + [route]);
    } else {
      this.router.navigate([route]);
    }
  }

  /**
   * @param {string[]} list
   */
  private translateItems(list: string[][]) {
    for (const item of list) {
      this.translationService.translateString(item[0]).then((translated) => {
        item[2] = translated;
      });
    }
  }
}
